import React from 'react'

export interface BaseIconProps {
  size?: number
}

export const BaseProviderIcon = ({
  size = 6,
  src,
  label
}: BaseIconProps & {
  label: string
  src: string
}) => {
  // Convert size to pixels (assuming the original size 6 meant 24px)
  const sizeInPixels = size * 4
  const wrapperPaddingClass = size <= 4 ? 'p-0.5' : 'p-1'

  return (
    <div
      className={`flex items-center justify-center rounded-md border border-gray-200 ${wrapperPaddingClass} dark:border-gray-700`}
    >
      <img
        style={{
          height: `${sizeInPixels}px`,
          width: `${sizeInPixels}px`
        }}
        src={src}
        aria-label={label}
        alt={label}
      />
    </div>
  )
}
